export enum ActionType {
  Add = 'ADD',
  Remove = 'REMOVE',
  Initialize = 'INITIALIZE',
  Destroy = 'DESTROY',
  UpdateState = 'UPDATE_STATE',
}

export enum LibraryState {
  Initializing = 'Initializing',
  Initialized = 'Initialized',
  Destroyed = 'Destroyed',
}
